import { flowType } from '../../Constants'
import { MotocyclesApi } from '../../api/motorcycles.api'
import { awaitWithLoading } from '../../services/utils'

export const MOST_COMMON_MAKES = ['BMW', 'Ducati', 'Harley-Davidson', 'Honda', 'Kawasaki', 'Suzuki', 'Triumph', 'Yamaha']

export const getEstimatedToolTip = billingFlowType => {
  const isEstimatedMileageState = billingFlowType === flowType.ESTIMATED_MILEAGE
  return isEstimatedMileageState
    ? 'Your estimation will be used to calculate the miles portion of the initial payment'
    : 'Your estimation will be used to calculate the monthly quote'
}

export const fetchModelsMethod = async (inputMake, inputYear, pushOther = true) => {
  if (inputMake == 'other') {
    return { models: [], showNewVehicleTextField: true }
  }

  let models = []
  let res = await MotocyclesApi.getModels(inputMake, inputYear)
  if (res.ok) {
    let tempModels = res.parsedData.motorcycle_models
    pushOther && tempModels.push('other')

    models = tempModels
  }

  return { models: models, showNewVehicleTextField: false }
}

export const fetchMakesMethod = async (inputYear, pushOther = true) => {
  if (inputYear == 'yeardefault' || inputYear == '1900') {
    return []
  }

  let res = await MotocyclesApi.getMakes(inputYear)
  let makes = []
  if (res.ok) {
    let tempMakes = res.parsedData.motorcycle_makes
    pushOther && tempMakes.push('other')
    makes = tempMakes
  }
  return makes
}

export const fetchYearsMethod = async (pushOther = true) => {
  let res = await MotocyclesApi.getModelYears()
  let years = []
  if (res.ok) {
    let tempYears = res.parsedData.motorcycle_years
    pushOther && tempYears.push('pre 1986')
    years = tempYears
  }
  return years
}

export const fetchRequestedMotorcyclesMethod = async (model, year) => {
  let res = await awaitWithLoading(MotocyclesApi.getRequestedMotorcycle(model, year))
  if (res.ok) {
    return { enginecCC: res.parsedData.engine_cc, type: res.parsedData.type }
  }
}

export const snwAtvQuestionAdjustments = type => {
  let antiLockFactorDisabled = type === 'snw' || type === 'atv' ? true : false
  let needOdometerCheck = type === 'snw' || type === 'atv' ? true : false

  return { isAntiLockFactorDisabled: antiLockFactorDisabled, isNeedOdometerCheck: needOdometerCheck }
}

export const validateOwnershipMethod = (ownershipPeriod, year) => {
  const currentdate = new Date()
  const vehicleAge = Math.max(currentdate.getFullYear() - year, 0)
  return vehicleAge >= ownershipPeriod
}
